import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

import { RootState } from "features/config/store";
import { AttendanceStaticData } from "features/ms6/core/domain/DailyStaticData.model";
import {
  DailyStaticDataRepository,
  DailyStaticDataResponse,
} from "features/ms6/data/ms6.repository";

export enum dailyStaticDataState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: dailyStaticDataState;
  message: string;
  data: AttendanceStaticData | undefined;
}

const initialState: InitialState = {
  status: dailyStaticDataState.initial,
  message: "",
  data: undefined,
};

export const dailyStaticData = createAsyncThunk(
  "dailyStaticData",
  async (_, { rejectWithValue }) => {
    try {
      const response: DailyStaticDataResponse =
        await DailyStaticDataRepository();
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const dailyStaticDataSlice = createSlice({
  name: "dailyStaticData",
  initialState,
  reducers: {
    resetdailyStaticData: (state) => {
      state.status = dailyStaticDataState.initial;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(dailyStaticData.pending, (state) => {
        state.status = dailyStaticDataState.inProgress;
      })
      .addCase(dailyStaticData.fulfilled, (state, action) => {
        if (action.payload) {
          const { message, data } = action.payload;
          state.status = dailyStaticDataState.success;
          state.message = message;
          state.data = data;
        }
      })
      .addCase(dailyStaticData.rejected, (state, action) => {
        state.status = dailyStaticDataState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectDailyStaticData = (state: RootState) =>
  state.dailyStaticData;
export const { resetdailyStaticData } = dailyStaticDataSlice.actions;
export default dailyStaticDataSlice.reducer;
